import { EnvironmentProviders, makeEnvironmentProviders, signal, Type } from '@angular/core';
import {
  AbstractDataGuardService,
  DataGuardSettings,
  DataGuardSettingsFactory,
  DataGuardTabID,
  provideDataGuardSettingsFactory
} from '@iot-platform/feature/data-guard';
import { AbstractI4BDataGuardService } from '../services/abstract-i4b-data-guard.service';

export function getEnvironmentProviders<T, U, S extends AbstractI4BDataGuardService<T, U>>(service): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideDataGuardSettingsFactory({
      dataGuardService: service,
      settingsFactory: ({ dataGuardService }): Partial<DataGuardSettings> => ({
        header: {
          enabled: signal(true),
          title: signal('DATA_GUARD.DRAWER_TITLE'),
          svgIcon: signal('data_guard'),
          infoIcon: signal(true),
          infoTooltip: signal('DATA_GUARD.TOOLTIP'),
          closeButton: signal(true)
        },
        content: {
          tabs: {
            [DataGuardTabID.DETAIL]: {
              label: signal('DATA_GUARD.TABS.DETAIL'),
              disabled: (dataGuardService as unknown as S).isDetailTabDisabled,
              active: (dataGuardService as unknown as S).isDetailTabActive,
              containsError: (dataGuardService as unknown as S).detailContainsError
            },
            [DataGuardTabID.OVERVIEW]: {
              label: signal('DATA_GUARD.TABS.OVERVIEW'),
              disabled: (dataGuardService as unknown as S).isOverviewTabDisabled,
              active: (dataGuardService as unknown as S).isOverviewTabActive,
              containsError: (dataGuardService as unknown as S).overviewContainsError
            }
          }
        }
      })
    })
  ]);
}
